import i18next from 'i18next';

i18next.addResources('es_CL', 'Stores', {
  getStoresError: 'Error al consultar las stores',
  getStoreByIDError: 'Error al consultar la store: {{id}}',
  updateStoreError: 'Error al actualizar la store'
});

i18next.addResources('es_CR', 'Stores', {
  getStoresError: 'Error al consultar las stores',
  getStoreByIDError: 'Error al consultar la store: {{id}}',
  updateStoreError: 'Error al actualizar la store'
});
